import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShiftSwapStatus } from '../../../../models/shiftSwap';
import { SWAP_STATUS_META } from './swapStatus';

interface StatusBadgeProps {
  status: ShiftSwapStatus;
}

// Color is the one place that carries meaning here, so each state owns a distinct,
// full-bordered pill (no side-stripe accents). The palette lives in swapStatus.ts so the
// hub's filter chips and this badge can never drift apart.
const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  const style = SWAP_STATUS_META[status] ?? SWAP_STATUS_META.Pending;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${style.pill}`}
      data-testid={`swap-status-${status}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${style.dot}`} aria-hidden="true" />
      {t(style.label)}
    </span>
  );
};

export default StatusBadge;
